import { createApp } from "vue";
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.css";
import bootsratp from "bootstrap/dist/js/bootstrap.bundle.js";
import i18n, { loadLocaleMessages } from "./i18n";
import router from "./router";
import "@/assets/scss/style.scss";
import "@/assets/libs/@iconscout/unicons/css/line.css";
//import '@/assets/libs/@mdi/font/css/materialdesignicons.min.css';

import MasonryWall from "@yeger/vue-masonry-wall";

const app = createApp(App);
app.use(MasonryWall);
app.use(router);
app.use(bootsratp);
app.use(i18n);
loadLocaleMessages(i18n.global.locale.value).then(() => {
  app.mount("#app");
});
